import AlarmProvider from '../providers/AlarmProvider'

var AlarmService = function () {
  return {
    GetSensorsByRailobjectId: function (railobjectId) {
      return AlarmProvider.GetSensorsByRailobjectId(railobjectId)
    }
  }
}

export default new AlarmService()



// WEBPACK FOOTER //
// ./src/services/AlarmService.js